'use strict';
var BuildingAnExpertDispensaryController = /** @class */ (function () {
    /*@ngInject*/
    function BuildingAnExpertDispensaryController($scope, EducationSubNavService) {
        this.headerContent = "You know that professional-grade supplements are essential for supporting optimal patient outcomes, but knowing which therapeutics to recommend and having the right systems in place to manage a successful dispensary can be a challenge. We have created 5 clinical and 5 business focused webinars to helping you build a thriving practice with enhanced patient outcomes, through the knowledge and confidence to recommend professional-grade supplements.";
        $scope.$ctrl.value.selectedpageindex = 0;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
    }
    return BuildingAnExpertDispensaryController;
}());
export default BuildingAnExpertDispensaryController;
//# sourceMappingURL=building-an-expert-dispensary.controller.js.map